import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Link from '../Link';
import s from './MiniNavSimple.css';

const MiniNavSimple = ({ paths }) => {
  let title;

  const links = paths.map((path, index) => {
    if (index === paths.length - 1) {
      title = path.title;

      return (
        <li key={path.url}>
          <span>{path.title}</span>
        </li>
      );
    }
    return (
      <li key={path.url}>
        <Link to={path.url}>{path.title}</Link>
        <i className="fa fa-angle-right" aria-hidden="true" />
      </li>
    );
  });

  return (
    <div className={s.root}>
      <h3 className={s.title}>{title}</h3>
      <ul className={s.breadcrumbs}>{links}</ul>
    </div>
  );
};

MiniNavSimple.propTypes = {
  paths: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
};

export default withStyles(s)(MiniNavSimple);



// WEBPACK FOOTER //
// ./src/components/MiniNavSimple/MiniNavSimple.js